import i18n from './form-validation-messages.properties';

export type ValidationMessageType = Exclude<keyof ValidityStateFlags, 'customError'> | 'outOfRange';

export function validationMessage (flag: ValidationMessageType, options?: Record<string, unknown>) {
  return i18n(`<${flag}>`, options);
}
